import * as React from 'react';

import { DocumentTitle, Spinner } from 'components/common';
import getDisplayName from 'authentication/helpers/getDisplayName';
import { AUTH_SERVICE_TYPE } from 'authentication/components/saml/constants';
import type AuthenticationBackend from 'logic/authentication/AuthenticationBackend';
import { fromAuthenticationBackend } from 'authentication/components/saml/config/helpers/samlConfigConverter';
import useSAMLTeamSyncConfig from 'authentication/components/saml/hooks/useSAMLTeamSyncConfig';

import SAMLBackendConfigSection from './SAMLBackendConfigSection';
import SAMLTeamSyncConfigSection from './SAMLTeamSyncConfigSection';

interface BackendConfigProps {
  authenticationBackend: AuthenticationBackend;
}

const SAMLBackendConfigDetails = ({ authenticationBackend }: BackendConfigProps) => {
  const { isLoading, teamSyncBackend } = useSAMLTeamSyncConfig(authenticationBackend.id);

  if (isLoading) {
    return <Spinner />;
  }

  const displayName = getDisplayName(AUTH_SERVICE_TYPE);
  const backend = fromAuthenticationBackend(authenticationBackend, teamSyncBackend);

  return (
    <DocumentTitle title={`${displayName} Authentication Services`}>
      <SAMLBackendConfigSection authenticationBackend={backend} />
      <SAMLTeamSyncConfigSection authenticationBackend={backend} />
    </DocumentTitle>
  );
};

export default SAMLBackendConfigDetails;
